import { REDUCER_KEY } from './reducer';

const getStore = (state) => state[REDUCER_KEY];
export const getClipboard = (state: any) => getStore(state).clipboard;
export const getClipboardForKey = (state: any, key: string) => getStore(state).clipboard.filter((x) => x.key === key);
